import { render } from "./MyServices.vue?vue&type=template&id=7f7b5beb&scoped=true"
import script from "./MyServices.vue?vue&type=script&lang=js"
export * from "./MyServices.vue?vue&type=script&lang=js"

import "./MyServices.vue?vue&type=style&index=0&id=7f7b5beb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f7b5beb"]])

export default __exports__